module.exports = __webpack_public_path__ + "static/img/apartmentverano.9acc8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/apartmentverano.png
// module id = XAi2
// module chunks = 0